export enum UserRole {
  CUSTOMER = 'CUSTOMER',
  AGENT = 'AGENT',
  BUSINESS_ADMIN = 'BUSINESS_ADMIN',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPPORT = 'SUPPORT',
  COMPLIANCE = 'COMPLIANCE',
}

export enum AgentStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum AgentBusinessType {
  INDIVIDUAL = 'INDIVIDUAL',
  SHOP = 'SHOP',
  KIOSK = 'KIOSK',
  FRANCHISE = 'FRANCHISE',
}

export enum FloatStatus {
  OK = 'OK',
  LOW = 'LOW',
  CRITICAL = 'CRITICAL',
  DEPLETED = 'DEPLETED',
}

export interface Agent {
  id: string;
  userId: string;
  agentCode: string;
  businessName: string;
  businessType: AgentBusinessType;
  commissionRate: number;
  status: AgentStatus;
  address: string;
  city: string;
  state: string;
  neighborhood?: string;
  coordinates?: { lat: number; lng: number };
  totalTransactions: number;
  totalVolume: number;
  rating?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CashFloat {
  id: string;
  agentId: string;
  currentBalance: number;
  minBalance: number;
  maxBalance: number;
  alertThreshold: number;
  status: FloatStatus;
  currency: string;
  lastReplenishmentAt?: string;
  updatedAt: string;
}

export interface AuthUser {
  id: string;
  username: string;
  email: string;
  phone?: string | null;
  firstName: string;
  lastName: string;
  roles: UserRole[];  // 🆕 Array de roles (multi-role support)
  role?: UserRole;    // ✅ Backward compatibility
  kycStatus: string;
  kycLevel: number;
  isActive: boolean;
}

export interface AgentProfile {
  agent: Agent;
  cashFloat: CashFloat;
  statistics: {
    totalEarnings: number;
    pendingCommissions: number;
    monthlyVolume: number;
    monthlyTransactions: number;
  };
}
